export class UserLogin {
  constructor(
    public username: string,
    public password: string,
    public appId: string
  ) {}
}
